export interface LNavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: LNavigationRoute[]
}

import { getUserRole } from '../../utils/userRoleUtils'

const userRole = getUserRole()
const filterRoutesByRole = (routes: LNavigationRoute[], role: string): LNavigationRoute[] => {
  return routes
    .filter((route) => {
      // Check if the route has allowed roles, and if the user's role is allowed
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true // Accessible by the user's role
      }
      // Fallback condition for routes without role restrictions (e.g., dashboard)
      if (!route.meta.allowedRoles) {
        return true // Accessible by everyone
      }
      return false // Hide route if not allowed for the user's role
    })
    .map((route) => {
      // Recursively filter children routes if any
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: filterRoutesByRole(
    [
      {
        name: 'dashboard',
        displayName: 'Dashboard',
        meta: {
          icon: 'vuestic-iconset-dashboard',
          allowedRoles: ['admin', 'analyst_viewer_org'],
        },
        children: [
          {
            name: 'performance',
            displayName: 'Driver Performance Dashboard',
            meta: { icon: 'monthly-dashboard-icon', allowedRoles: ['admin', 'analyst_viewer_org'] },
          },
        ],
      },
      {
        name: 'drivers',
        displayName: 'Drivers',
        meta: { icon: 'moped', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'our-drivers',
        displayName: 'Our Drivers',
        meta: { icon: 'person', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'tickets',
        displayName: 'Tickets',
        meta: { icon: 'assignment', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'vehicles',
        displayName: 'Vehicles',
        meta: { icon: 'commute', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'our-vehicles',
        displayName: 'Our Vehicles',
        meta: { icon: 'directions_car', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'bikes',
        displayName: 'Bikes',
        meta: { icon: 'two_wheeler', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'trips',
        displayName: 'Trips',
        meta: { icon: 'folder_shared', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'messages',
        displayName: 'Messages',
        meta: { icon: 'message', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'driver-training',
        displayName: 'Driver Training',
        meta: { icon: 'school', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'reports',
        displayName: 'Reports',
        meta: { icon: 'today', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'analytics',
        displayName: 'Analytics',
        meta: { icon: 'analytics', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'teams',
        displayName: 'Teams',
        meta: { icon: 'folder', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'issues',
        displayName: 'Issues',
        meta: { icon: 'warning', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'alarms',
        displayName: 'Alarms',
        meta: { icon: 'notifications', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'maintenance',
        displayName: 'Maintenance',
        meta: { icon: 'engineering', allowedRoles: ['admin', 'analyst_viewer_org'] },
        children: [
          {
            name: 'maintenance',
            displayName: 'Maintenance List',
            meta: { icon: 'list', allowedRoles: ['admin', 'analyst_viewer_org'] },
          },
          {
            name: 'maintenance-items',
            displayName: 'Maintenance Items',
            meta: { icon: 'inventory', allowedRoles: ['admin', 'analyst_viewer_org'] },
          },
          {
            name: 'maintenance-workshops',
            displayName: 'Workshops',
            meta: { icon: 'business', allowedRoles: ['admin', 'analyst_viewer_org'] },
          },
        ],
      },
      {
        name: 'ev-dashboard',
        displayName: 'EV Dashboard',
        meta: { icon: 'electric_car', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'compare',
        displayName: 'Compare',
        meta: { icon: 'compare_arrows', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'faq',
        displayName: 'FAQ',
        meta: { icon: 'help', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'settings',
        displayName: 'Settings',
        meta: { icon: 'settings', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
      {
        name: 'preferences',
        displayName: 'Profile',
        meta: { icon: 'manage_accounts', allowedRoles: ['admin', 'analyst_viewer_org'] },
      },
    ],
    userRole,
  ),
}

export default sidebarRoutes
